module.exports = __webpack_public_path__ + "img/adfc3e5.png";